<template>
  <div class="asset-dynamics">
    <div
      v-show="isAssetDynamicsLoading"
      class="preloader asset-dynamics__preloader"
    >
      <spinner :animation-duration="1000" :size="60" :color="'#2E79EF'" />
    </div>
    <div class="row justify-between align-center">
      <h4 class="heading">{{ $t("asset dynamics") }}</h4>
      <div class="asset-dynamics__controls controls row">
        <horizontal-button-group
          :options="[
            { value: 'month', text: $t('month') },
            { value: 'quarter', text: $t('quarter') },
            { value: 'year', text: $t('year') }
          ]"
          @handleClick="changeSelect"
          class="controls__item controls__date-template-picker"
        />
        <date-picker
          :lang="$t('short lang')"
          :range="true"
          :confirm="true"
          class="controls__item controls__date-picker"
          value-type="format"
          v-model="dateRange"
          @change="handleDatePickerChange"
          :clearable="false"
          :placeholder="$t('select date range')"
          :not-after="new Date()"
          format="DD.MM.YYYY"
        />
      </div>
    </div>
    <highchart
      :options="assetDynamicsChartOptions"
      class="asset-dynamics__chart"
      :class="{ 'asset-dynamics__chart_hidden': isAssetDynamicsLoading }"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import { HalfCircleSpinner } from "epic-spinners";
import HorizontalButtonsGroup from "@/components/ui-kit/HorizontalButtonsGroup";
import HighChartsDrillDown from "highcharts/modules/drilldown";
import i18n from "@/lib/vue-i18n/index";
HighChartsDrillDown(Highcharts);

Highcharts.setOptions({
  lang: {
    decimalPoint: ",",
    drillUpText: "<",
    numericSymbols: [null, i18n.t("Mln"), i18n.t("Bil"), "T", "P", "E"]
  },
  chart: {
    style: {
      fontFamily: "Gerbera"
    }
  }
});

export default {
  data() {
    return {
      selectType: "month"
    };
  },
  components: {
    highchart: Chart,
    "date-picker": DatePicker,
    spinner: HalfCircleSpinner,
    "horizontal-button-group": HorizontalButtonsGroup
  },
  computed: {
    // Возвращаем настройки для графика
    assetDynamicsChartOptions() {
      return {
        chart: {
          type: "column"
        },
        title: {
          text: ""
        },
        subtitle: {
          text: ""
        },
        xAxis: {
          type: "category"
        },
        yAxis: {
          title: {
            text: i18n.t("amount in ") + this.$store.getters.currencySign
          },
          type: "{point.y:.1f} "
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format:
                // Выводим знак текущей выбранной валюты
                " {point.y:,.0f} " + this.$store.getters.currencySign + "</b>"
            }
          }
        },
        lang: {
          thousandsSep: " "
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}</b> ' +
            this.$store.getters.currencySign +
            "<br/>"
        },

        series: [
          {
            name: i18n.t("asset dynamics"),
            colorByPoint: false,
            data: this.displayByType
          }
        ]
      };
    },
    // Используя текущее условие отображения выводим данные в удобочитаемом для графика виде
    displayByType() {
      let balance = this.$store.getters.assetDynamics;
      let chartData = [];
      balance.forEach(value => {
        chartData.push({
          name: value.date,
          y: parseFloat(
            value[this.$store.getters.getSelectedCurrency].replace(",", ".")
          )
        });
      });
      return chartData;
    },
    ...mapGetters(["isAssetDynamicsLoading", "getAssetDynamicsDateRange"]),
    // ...mapGetters({
    //   dateRange: "getAssetDynamicsDateRange"
    // }),
    dateRange: {
      get() {
        return this.getAssetDynamicsDateRange;
      },
      set(value) {
        this.$store.commit("setAssetDynamicsDateRange", value);
      }
    }
  },
  methods: {
    changeSelect(value) {
      this.selectType = value;
      switch (value) {
        case "month":
          this.dateRange = [
            moment()
              .subtract(1, "months")
              .format("DD.MM.YYYY"),
            moment().format("DD.MM.YYYY")
          ];
          break;
        case "quarter":
          this.dateRange = [
            moment()
              .subtract(3, "months")
              .format("DD.MM.YYYY"),
            moment().format("DD.MM.YYYY")
          ];
          break;
        case "year":
          this.dateRange = [
            moment()
              .subtract(1, "years")
              .format("DD.MM.YYYY"),
            moment().format("DD.MM.YYYY")
          ];
          break;
      }
      this.$store.dispatch("clearAssetDynamics");
      this.$store.dispatch(
        "fetchAssetDynamics",
        this.getFormatedDateRange(this.dateRange)
      );
    },
    handleDatePickerChange(dateRange) {
      this.$store.dispatch("clearAssetDynamics");
      this.$store.dispatch(
        "fetchAssetDynamics",
        this.getFormatedDateRange(dateRange)
      );
    },
    getFormatedDateRange(dateRange) {
      return {
        bdate: dateRange[0],
        edate: dateRange[1],
        currency: this.$store.getters.displayingCurrency
      };
    }
  },
  mounted() {
    this.$store.dispatch("fetchAssetDynamics");
  }
};
</script>
<style scoped>
.heading {
  font-size: 36px;
  font-weight: normal;
  color: #222c44;
}
.asset-dynamics__chart {
  margin-top: 30px;
}

.asset-dynamics__chart_hidden {
  visibility: hidden;
}

.asset-dynamics__prealoder {
  z-index: 5;
}

.controls__item {
  height: 34px;
  box-sizing: border-box;
}

.controls__date-picker {
  padding: 0 20px;
}
</style>
